module.exports = __webpack_public_path__ + "img/user-12.9af474c7.svg";